// extracted by mini-css-extract-plugin
module.exports = {"purpleContainer":"PurpleSection_purpleContainer__1jKHK","text":"PurpleSection_text__x4WoC"};